import { render, staticRenderFns } from "./InsFreshness.vue?vue&type=template&id=4185e992&scoped=true"
import script from "./InsFreshness.vue?vue&type=script&lang=js"
export * from "./InsFreshness.vue?vue&type=script&lang=js"
import style0 from "./InsFreshness.vue?vue&type=style&index=0&id=4185e992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4185e992",
  null
  
)

export default component.exports